import { Cog8ToothIcon } from "@heroicons/react/24/solid"
import { LazyLoadImage } from "react-lazy-load-image-component"

export const MaintenancePage = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-between">
            <LazyLoadImage
                alt=""
                className="object-cover auto min-h-full h-16 md:h-14 my-4"
                effect="opacity"
                src={`/images/logofull.png`}
            />
            <div className="flex flex-col justify-center items-center text-center text-lg">
                <Cog8ToothIcon className="size-24 mb-5" />
                <p>Przerwa techniczna ... </p>
                <p>Zaraz wracamy</p>
            </div>
            <div className="h-20"/>
        </div>
    )
}
